<script setup lang="tsx">
import { computed, ref } from 'vue'
import http from '@/services/http'

const code = ref('')
const isBusy = ref(false)
const isValid = computed(() => /([0-9]{4})-([0-9]{4})-([0-9]{4})-([0-9]{4})/.test(code.value))

async function activate() {
	isBusy.value = true
	const { status } = await http.post('license', code.value)
	isBusy.value = false

	if (status === 200) location.reload()
}
</script>

<template>
	<div class="row my-3">
		<div class="col-md-4 text-start text-nowrap">
			<label for="license" class="col-form-label">{{ $t('licenseCode') }}</label>
		</div>
		<div class="col-md-8">
			<input
				id="license"
				type="text"
				class="form-control"
				:class="{ 'is-invalid': code.length && !isValid }"
				v-model="code"
				maxlength="19"
			/>
		</div>
	</div>
	<div class="row">
		<div class="col">
			<button id="activate-btn" class="btn btn-primary w-100" :disabled="isBusy || !isValid" @click="activate">
				<template v-if="isBusy">
					<div class="spinner-border spinner-border-sm"></div>
				</template>
				<template v-else>{{ $t('activate') }}</template>
			</button>
		</div>
	</div>
</template>

<style lang="sass" scoped></style>
